// extracted by mini-css-extract-plugin
export var infoItem = "_s0-2";
export var title = "_s0-0";
export var value = "_s0-1";